import(/* webpackMode: "eager", webpackExports: ["PerpTradingPage"] */ "/home/runner/work/stackd-perps/stackd-perps/packages/stackd-perps/client/pages/PerpTrading/PerpTradingPage.tsx");
